import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_325: DocMigration = {
  maxSchemaVersion: "0.0.325",
  description: "add START default to openings for paramAnchor if not exists",
  apply(json: any) {
    const { openings } = json;

    // iterate over openings
    for (const openingId in openings) {
      const opening = openings[openingId];
      if (
        opening.type !== "DOOR" &&
        opening.type !== "WINDOW" &&
        opening.type !== "DOOR_V2" &&
        opening.type !== "WINDOW_V2"
      ) {
        continue;
      }

      const { paramAnchor } = opening;
      if (paramAnchor !== undefined) {
        continue;
      }

      openings[openingId].paramAnchor = "START";
    }

    return json;
  },
};

export default migration_0_0_325;
